import { usersConstants } from '../constants';
import {List} from "immutable";

export function users(state = {}, action) {
  switch (action.type) {
    case usersConstants.GETUSERS_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        data: new List()
      });
    case usersConstants.GETUSERS_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.data
      });
    case usersConstants.GETUSERS_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: action.error
      });
    default:
      return state
  }
}
